
import AuthProvider from "../components/AuthProvider";

export function auth(pageComponent) {
    return (
        <AuthProvider>
            {pageComponent}
        </AuthProvider>
    );
}